/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, message, Table } from "antd";
import { ReportsService } from "../../../../services/api/reports";
import Heading from "../../../../components/Heading";
import "../styles.scss";

const DeliveryDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [detailsData, setDetailsData] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });

    const { date, cpId, key, type, hubName, cpName, hubId, isNewReport, fromDate, toDate } = location.state || {};
    console.log("location.state", location.state);

    // Single useEffect for initial validation and data fetch
    useEffect(() => {
        if (!key) {
            message.error("Invalid parameters");
            navigate("/delivery-mis-report");
            return;
        }
        fetchDetails(1, pagination.pageSize);
    }, []); // Only run once on mount

    const fetchDetails = async (page = 1, pageSize = 10) => {
        if (!key) return;

        setLoading(true);
        try {
            const a3Keys = [
                "outscanned", "inscanned", "notInScan", "drsGenerationByCPOfSameDay",
                "delivered", "undelivered", "rto", "rtoOfd", "rtoDelivered", "rtoUndelivered"
            ];

            if (isNewReport && a3Keys.includes(key)) {
                let endpoint = "";
                let bearerToken = "";
                let statusLabel = "";

                if (key === "outscanned") {
                    endpoint = "clickable_del_mis_outscan_to_cp";
                    bearerToken = "a3b1279946fdae89b09fb2bc1071d08b032996d322984209832f7b35e1202a0f";
                    statusLabel = "Outscanned";
                } else if (key === "inscanned") {
                    endpoint = "clickable_del_mis_inscan_same_day";
                    bearerToken = "f357cb04963d0590fcb2af2c2136c7a396c18485b578fa9f2e6aaae9c91e5cf1";
                    statusLabel = "Inscanned (Same Day)";
                } else if (key === "notInScan") {
                    endpoint = "clickable_del_mis_not_same_day_inscan";
                    bearerToken = "cb6caa31ca72c5fa6bdb969f83acc73e9086a20a2c9aa130fe4ea542a5103454";
                    statusLabel = "Not Inscanned (Same Day)";
                } else if (key === "drsGenerationByCPOfSameDay") {
                    endpoint = "clickable_del_mis_same_day_ofd";
                    bearerToken = "9e3413e9a1e01a2552dd67a4cac033ce3dda2ce3bc0c32d18a55fbfb97a60e7d";
                    statusLabel = "OFD (Same Day)";
                } else if (key === "delivered") {
                    endpoint = "clickable_del_mis_same_day_delivered";
                    bearerToken = "e954f371a5d09c035af6b27d2ea34f2717daf05ec476674ee638398c040e766e";
                    statusLabel = "Delivered (Same Day)";
                } else if (key === "undelivered") {
                    endpoint = "clickable_del_mis_same_day_undelivered";
                    bearerToken = "b19faef7c08fb702022595326bf82c41a6d4e100cf800af8d8e27a102ac13737";
                    statusLabel = "Undelivered (Same Day)";
                } else if (key === "rto") {
                    endpoint = "clickable_del_mis_same_day_rto_initiated";
                    bearerToken = "2a6fef9dc9e27119ce3a4cc458ba36c58c7952a5d1cced2f05c1709a28f02c00";
                    statusLabel = "RTO Initiated (Same Day)";
                } else if (key === "rtoOfd") {
                    endpoint = "clickable_del_mis_same_day_rto_ofd";
                    bearerToken = "0fdc884eb8aee7a6fd5eb6043b4d3debc7f51e7d85b38913a1f08d65c862a662";
                    statusLabel = "RTO OFD (Same Day)";
                } else if (key === "rtoDelivered") {
                    endpoint = "clickable_del_mis_same_day_rto_delivered";
                    bearerToken = "2efae63d71047b04836c2bbc9b7d17dff6ead9925746312fc4451c629c58b042";
                    statusLabel = "RTO Delivered (Same Day)";
                } else if (key === "rtoUndelivered") {
                    endpoint = "clickable_del_mis_same_day_rto_undelivered";
                    bearerToken = "591badb9c2d445a309ea1b310b42790bb841c42b6237b42e46f37e13dcced305";
                    statusLabel = "RTO Undelivered (Same Day)";
                }

                //console.log("Routing via New Report A3 integration:", { key, endpoint, statusLabel, bearerToken: bearerToken.substring(0, 10) + "..." });

                const queryParams = new URLSearchParams({
                    fromDate_outscan_date: fromDate || date,
                    toDate_outscan_date: toDate || date,
                    from_hub_id: hubId,
                    to_channel_partner: cpName,
                    page: page,
                    size: pageSize
                });

                const url = `https://a3-framework.prayog.io/dynamic/${endpoint}?${queryParams.toString()}`;

                const body = {
                    user_name: "laxminandan",
                    user_email: "laxminandan.handique@shreemaruti.com"
                };

                const fetchResponse = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${bearerToken}`,
                    },
                    body: JSON.stringify(body)
                });

                const responseData = await fetchResponse.json();

                if (responseData?.code === 200 || responseData?.success) {
                    const data = responseData?.data || [];
                    const mappedData = data.map(item => ({
                        ...item,
                        awbNumber: item.awb_number,
                        currentStatus: statusLabel
                    }));
                    setDetailsData(mappedData);
                    setPagination(prev => ({
                        ...prev,
                        total: responseData.total_records || data.length
                    }));
                } else {
                    setDetailsData([]);
                    setPagination(prev => ({ ...prev, total: 0 }));
                    message.error(responseData?.message || "No data available");
                }
            } else {
                if (!date || !cpId || !hubId) {
                    setLoading(false);
                    return;
                }
                const response = await ReportsService.getDRSReport({
                    startDate: date,
                    endDate: date,
                    cpId: cpId,
                    key: key,
                    page: page,
                    limit: pageSize,
                    hubId: hubId
                });

                if (response?.data) {
                    setDetailsData(response.data);
                    setPagination(prev => ({
                        ...prev,
                        total: response.total || 0
                    }));
                } else {
                    setDetailsData([]);
                    setPagination(prev => ({
                        ...prev,
                        total: 0
                    }));
                    message.error("No data available");
                }
            }
        } catch (error) {
            console.error("Error fetching details:", error);
            message.error(error?.message || "Failed to fetch details");
            setDetailsData([]);
            setPagination(prev => ({
                ...prev,
                total: 0
            }));
        } finally {
            setLoading(false);
        }
    };

    const handleTableChange = (newPagination) => {
        fetchDetails(newPagination.current, newPagination.pageSize);
    };

    const columns = [
        {
            title: "AWB Number",
            dataIndex: "awbNumber",
            key: "awbNumber",
            width: 150,
            render: (text) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        const url = `/shipment-tracker?awb=${text}`;
                        window.open(url, "_blank");
                    }}
                >
                    {text}
                </span>
            )
        },
        ...(isNewReport ? [
            {
                title: "From Hub",
                dataIndex: "from_hub",
                key: "from_hub",
                width: 150,
            },
            {
                title: "Inscan CP",
                dataIndex: "inscan_cp",
                key: "inscan_cp",
                width: 150,
                render: (text) => text || "---"
            },
            {
                title: "OFD Date Time",
                dataIndex: "ofd_date_time",
                key: "ofd_date_time",
                width: 180,
                render: (text) => text || "---"
            },
            {
                title: "Outscan Date Time",
                dataIndex: "outscan_date_time",
                key: "outscan_date_time",
                width: 180,
                render: (text) => text || "---"
            },
            {
                title: "To Channel Partner",
                dataIndex: "to_channel_partner",
                key: "to_channel_partner",
                width: 150,
            }
        ] : [
            {
                title: "Status",
                dataIndex: "currentStatus",
                key: "currentStatus",
                width: 120,
            },
        ])
    ];

    return (
        <div className="report-container">
            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                <Heading
                    title={`${type} Details`}
                />
            </div>
            <Card className="report-card">
                <div style={{ fontSize: "16px", fontWeight: "500", display: "flex", gap: "8px", alignItems: "center" }}>
                    <div style={{ padding: "8px 16px", background: "#f5f5f5", borderRadius: "4px" }}>
                        <span style={{ color: "#666" }}>Hub:</span> {hubName}
                    </div>
                    <div style={{ padding: "8px 16px", background: "#f5f5f5", borderRadius: "4px" }}>
                        <span style={{ color: "#666" }}>CP:</span> {cpName}
                    </div>
                </div>
                <Table
                    columns={columns}
                    dataSource={detailsData}
                    loading={loading}
                    pagination={pagination}
                    onChange={handleTableChange}
                    scroll={{ y: "calc(100vh - 300px)", x: "max-content" }}
                    sticky
                />
            </Card>
        </div>
    );
};

export default DeliveryDetails;

